import { useEffect } from "react";

export function useDocumentUrlSync({ document, project, hash, history }) {
  useEffect(() => {
    const isDocInProject = document?.id && (project?.contents?.find((item) => item.id === document.id) || project?.deletedDocuments?.find((item) => item.id === document.id));
    // Do not throttle navigation: create-then-open can select two documents in one frame.
    if (isDocInProject && !hash.includes(document.id)) {
      const urlParams = new URLSearchParams(window.location.search);
      if (!urlParams.has("sb")) {
        history.replace({ hash: "doc=" + document.id });
      }

      if (project) {
        project.update({
          activeDocument: document.id,
        });
      }
    }
  }, [document]);
}
